declare namespace $ {

	type $mol_view__sub_bog_merchquarium_start_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_start_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_start_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_merchquarium_start_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_merchquarium_start_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_bog_merchquarium_start_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_merchquarium_start_7 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_start['create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_paragraph__title_bog_merchquarium_start_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_merchquarium_start_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_bog_merchquarium_start_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_merchquarium_start_11 = $mol_type_enforce<
		ReturnType< $bog_merchquarium_start['point_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_merchquarium_start_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_merchquarium_start extends $mol_view {
		Logo_icon( ): $mol_icon_fish
		Logo( ): $mol_view
		Brand( ): $mol_paragraph
		Tagline( ): $mol_paragraph
		Lead( ): $mol_paragraph
		Points( ): $mol_list
		create( next?: any ): any
		Create( ): $mol_button_major
		Note( ): $mol_paragraph
		Card( ): $mol_list
		point_icon( id: any): $mol_icon
		Point_icon( id: any): $mol_view
		point_text( id: any): string
		Point_text( id: any): $mol_paragraph
		sub( ): readonly(any)[]
		Point( id: any): $mol_view
		Icon_cards( ): $mol_icon_image_multiple
		Icon_orders( ): $mol_icon_send_outline
		Icon_search( ): $mol_icon_magnify
		cards_text( ): string
		orders_text( ): string
		search_text( ): string
	}
	
}

//# sourceMappingURL=start.view.tree.d.ts.map